<app-sign-in-form
  (formSubmitted)="signIn($event)"
  [errorMessage]="errorMessage"
  [registrationAvailable]="registrationAvailable"
></app-sign-in-form>
